import { render } from "./Paiement.vue?vue&type=template&id=5b7a670d&scoped=true"
import script from "./Paiement.vue?vue&type=script&lang=js"
export * from "./Paiement.vue?vue&type=script&lang=js"

import "./Paiement.vue?vue&type=style&index=0&id=5b7a670d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7a670d"]])

export default __exports__